module.exports = __webpack_public_path__ + "static/media/24.fd16fb35.mp3";